import { render } from "./CardIcon.vue?vue&type=template&id=4f59c95e"
import script from "./CardIcon.vue?vue&type=script&lang=js"
export * from "./CardIcon.vue?vue&type=script&lang=js"
script.render = render

export default script